import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.user');
import { switchPortalMode } from "src/libs/portal-mode-transition";
import { OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.user/view.scss */
/* src/app/component.nav.user/view.scss: no such file or directory */`],
})
export class ComponentNavUserComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef) { }

    public userMenu = [
        { id: 'dashboard', label: '대시보드', icon: 'Grip', path: '/dashboard', ctf: false },
        {
            id: 'group', label: '연구그룹', icon: 'Rectangle', breakBefore: true,
            children: [
                { id: 'list', label: '그룹 목록', icon: 'Bars', path: '/group/list' },
                { id: 'request', label: '신청·승인 내역', icon: 'Envelope', path: '/group/request' }
            ],
            ctf: true
        },
        { id: 'storage', label: '스토리지', icon: 'Storage', path: '/storage', ctf: false },
        { id: 'research', label: '연구성과', icon: 'Chart', path: '/research', ctf: false },
        { id: 'notice', label: '공지사항', icon: 'Megaphone', path: '/notice', ctf: false, breakBefore: true },
        { id: 'board', label: '게시판', icon: 'Message', path: '/board', ctf: false },
        {
            id: 'support', label: '기술지원', icon: 'Wrench', breakBefore: true,
            children: [
                { id: 'manual', label: '매뉴얼', icon: 'FileLines', path: '/support/manual' },
                { id: 'faq', label: 'FAQ', icon: 'Question', path: '/support/faq' },
                { id: 'ticketing', label: '문의하기', icon: 'Ticket', path: '/support/ticketing' }
            ],
            ctf: true
        },
    ];

    public expandedMenus: Record<string, boolean> = {};
    private navSub: any;

    public session: any;
    public menusReady = false;

    public userInfo: any = {
        account_name: '',
        email: '',
        roles: []
    };

    @ViewChild('accountRoot') private accountRoot?: ElementRef<HTMLElement>;
    @ViewChild('accountTrigger') private accountTrigger?: ElementRef<HTMLButtonElement>;
    public accountMenuOpen = false;

    public toggleAccountMenu() {
        this.accountMenuOpen = !this.accountMenuOpen;
        this.cdr.detectChanges();
        if (this.accountMenuOpen) {
            this.accountRoot?.nativeElement.querySelector<HTMLElement>('nav a')?.focus({ preventScroll: true });
        }
    }

    public closeAccountMenu(restoreFocus = false) {
        if (!this.accountMenuOpen) return;
        this.accountMenuOpen = false;
        this.cdr.detectChanges();
        if (restoreFocus) this.accountTrigger?.nativeElement.focus({ preventScroll: true });
    }

    public onAccountKeydown(event: KeyboardEvent) {
        if (event.key !== 'Escape' || !this.accountMenuOpen) return;
        event.preventDefault();
        event.stopPropagation();
        this.closeAccountMenu(true);
    }

    public onAccountFocusout(event: FocusEvent) {
        if (!this.accountRoot?.nativeElement.contains(event.relatedTarget as Node)) this.closeAccountMenu();
    }

    @HostListener('document:pointerdown', ['$event'])
    public onOutsideAccountClick(event: PointerEvent) {
        if (!this.accountRoot?.nativeElement.contains(event.target as Node)) this.closeAccountMenu();
    }

    @HostListener('window:resize')
    public onAccountResize() {
        this.closeAccountMenu();
    }

    public async switchMode(event: MouseEvent, path: string) {
        try {
            await switchPortalMode(event, this.router, path);
        } catch (_) {
            await this.service.alert.error('화면을 전환하지 못했습니다. 다시 시도해주세요.');
        }
    }

    public get canSwitchMode(): boolean {
        return this.userInfo?.can_manage === true && this.session?.membership === 'admin'
            && this.session.role !== 'admin' && !!this.session.community_id;
    }

    public get managementPath(): string[] {
        return this.session?.role === 'admin'
            ? ['/admin/community']
            : ['/admin/community', this.session?.community_id, 'info'];
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        this.session = this.service.auth.session;
        this.expandCurrentMenu();
        this.navSub = this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe(async () => {
                this.accountMenuOpen = false;
                this.expandCurrentMenu();
                await this.service.render();
            });
        try {
            await this.load();
        } finally {
            this.menusReady = true;
            await this.service.render();
        }
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return await this.service.alert.error("Error!");
        this.userInfo = data;
        await this.service.render();
    }

    public hasAuth(roles: string) {
        return roles.split(',').includes(this.session?.role);
    }

    public manager(roleList: any) {
        return Array.isArray(roleList) && roleList.includes('서비스 담당자');
    }

    public async toggleMenu(menuId: string, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.expandedMenus = {
            ...this.expandedMenus,
            [menuId]: !this.expandedMenus[menuId]
        };
        this.cdr.detectChanges();
        await this.service.render();
    }

    public isActive(link: string) {
        const path = this.router.url.split(/[?#]/)[0];
        return !!link && (path === link || path.startsWith(link + '/'));
    }

    public isSectionActive(item: any) {
        return item.children?.some((child: any) => this.isActive(child.path)) || false;
    }

    private expandCurrentMenu() {
        for (const item of this.userMenu) {
            if (this.isSectionActive(item)) this.expandedMenus[item.id] = true;
        }
    }

    public ngOnDestroy() {
        this.navSub?.unsubscribe();
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            Ticket: 'fa-solid fa-ticket',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Grip: 'fa-solid fa-grip',
            Clipboard: 'fa-solid fa-clipboard',
            Question: 'fa-solid fa-clipboard-question',
            FileLines: 'fa-solid fa-file-lines',
            Group: 'fa-solid fa-users-viewfinder',
            Rectangle: 'fa-solid fa-users-rectangle',
            Wrench: 'fa-solid fa-screwdriver-wrench',
            Chart: 'fa-solid fa-chart-column',
            Envelope: 'fa-solid fa-envelope-circle-check',
            Bars: 'fa-solid fa-bars',
            Megaphone: 'fa-solid fa-bullhorn',
            Message: 'fa-solid fa-message',
            Storage: 'fa-solid fa-box'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }

    public async logout() {
        sessionStorage.clear();
        window.location.href = '/auth/logout';
    }
}

export default ComponentNavUserComponent;